app.service('giftCardPaymentView', function (console, validate, modal, orderConfig, orderUtils, broker, paymentOperator) {
	var $self, $form, $paymentType, $eTransferBanks, $eTransferBank, $navButton, $permissions;
	var config;
	var isOneInit = false;

	function next() {
		if ($form.valid()) {
			send('NEXT');
		}
	}
	function selectPaymentType(paymentCode) {
		config.paymentCode = parseInt(paymentCode);
		console.log('WYBÓR PŁATNOŚCI: ' + config.paymentCode);
		if (config.paymentCode === 14) {
			$self.addClass('master-pass');
		} else {
			$self.removeClass('master-pass');
		}
		if (config.paymentCode === 19) {
			$self.addClass('blik');
		} else {
			$self.removeClass('blik');
		}
		if (config.paymentCode === 20) {
			$self.addClass('google-pay');
		} else {
			$self.removeClass('google-pay');
		}
		if (config.paymentCode === 21) {
			$self.addClass('payu-pay-later');
		} else {
			$self.removeClass('payu-pay-later');
		}
		if (paymentCode === 22) {
			$self.addClass('apple-pay');
		} else {
			$self.removeClass('apple-pay');
		}
		if (paymentCode === 23) {
			$self.addClass('visa-mobile');
		} else {
			$self.removeClass('visa-mobile');
		}
		if (paymentCode === 24) {
			$self.addClass('blik-pay-later');
		} else {
			$self.removeClass('blik-pay-later');
		}
		if (paymentCode === 25) {
			$self.addClass('blik-one-click');
		} else {
			$self.removeClass('blik-one-click');
		}
		if (config.paymentCode === 4) {
			$self.addClass('e-card');
		} else {
			$self.removeClass('e-card');
		}
		if (config.paymentCode === 3) {
			$self.addClass('e-transfer');
			$eTransferBank.ignore(false);
		} else {
			$self.removeClass('e-transfer');
			$eTransferBank.ignore(true);
		}
	}
	function updatePaymentTypeInCart(paymentCode) {
		selectPaymentType(paymentCode);
		$permissions.addClass('loading');
		$navButton.addClass('loading');
		$.ajax({
			url: '/gift-card-order-switch-payment.ltr',
			type: 'post',
			dataType: 'json',
			data: {
				paymentTypeCode: paymentCode
			},
			success: function (json) {
				paymentOperator.change(json.paymentOperator, json.paymentOperatorRegulationUrl);
				$navButton.removeClass('loading');
				$permissions.removeClass('loading');
				let $box = $('#preview-list');
				$box.attr('wdio-ready', parseInt(Math.random()*1000000000));
			}, error: function () {
				$navButton.removeClass('loading');
				$permissions.removeClass('loading');
				modal.alert('Błąd ustawiania rodzaju płatności. Spróbuj ponownie')
			}
		});
	}
	function send(action) {
		orderUtils.send(action);
	}
	function back() {
		orderUtils.back();
	}
	function setElements() {
		$self = $('#gift-card-payment #container');
		$form = $('form', $self);
		$paymentType = $('.js-payment-type', $self);
		$eTransferBank = $('#e-transfer-banks .js-selected-bank', $self);
		$eTransferBanks = $('#e-transfer-banks .js-bank-select', $self);
		$navButton = $('.nav-buttons', $self);
		$permissions = $('#permissions', $self);
		config = orderConfig.getData();
	}
	function updateBank(eTransferBankId) {
		console.log('UPDATE PAYMENT BANK with bankId:' + eTransferBankId);
		$permissions.addClass('loading');
		$navButton.addClass('loading');
		$eTransferBank.val(eTransferBankId).valid();
		$eTransferBanks.removeClass('active').filter('[data-id=' + eTransferBankId + ']').addClass('active');
		$.ajax({
			url: '/gift-card-order-switch-payment-bank.ltr',
			dataType: 'json',
			type: 'post',
			data: {
				eTransferBankId
			},
			success: function (json) {
				paymentOperator.change(json.paymentOperator, json.paymentOperatorRegulationUrl);
				$navButton.removeClass('loading');
				$permissions.removeClass('loading');
				let $box = $('#preview-list');
				$box.attr('wdio-ready', parseInt(Math.random()*1000000000));
			}, error: function () {
				$navButton.removeClass('loading');
				$permissions.removeClass('loading');
				modal.alert('Błąd ustawiania banku. Spróbuj ponownie');
			}
		});

	}
	function setEvents() {
		$('.js-payment-next', $self).on('click', function () {
			next();
		});
		$('.js-payment-back', $self).on('click', function () {
			back();
		});
		$eTransferBanks.on('click', function () {
			updateBank($(this).data('id') / 1);
		});
		$paymentType.on('click', function () {
			let newValue = parseInt($(this).val());
			if (config.paymentCode != newValue) {
				updatePaymentTypeInCart(newValue);
				$.scrollTo($(this).parent());
			}
		});
		validate.task('giftCardPayment');
	}
	function init() {
		setElements();
		setEvents();
		if (config.paymentCode !== false) {
			selectPaymentType(config.paymentCode);
		}
		paymentOperator.init();
		if (!isOneInit) {
			broker.on('ORDER-NEXT-STEP', function () {
				if(front.page() == 'gift-card-payment'){
					// obecnie nic
				}
			});
			isOneInit = true;
		}
	}
	return {
		init: init
	};
});
